// Why a document was deleted — required on every delete (stage 0 of the
// draft-review roadmap; deletions by reason are one of its numbers).
//
// SYNC PAIR: `server/lib/softDelete.js` (DELETION_REASONS, REASON_NOTE_MAX).
// The server validates the key and the note; this copy exists so the chips
// have something to draw and the button can stay disabled until the answer is
// complete. Change one → change the other, or the dialog offers a chip the
// server rejects with a 400. The KEY is what is stored; labels are copy.
export const DELETION_REASONS = [
  { key: 'duplicate',        label: 'כפול' },
  { key: 'wrong_restaurant', label: 'לא שייך למסעדה הזו' },
  { key: 'unreadable',       label: 'סריקה לא קריאה' },
  // None of the above — the note says what.
  { key: 'other',            label: 'אחר' },
];

export const DELETION_REASON_NOTE_MAX = 200;

// How long a deleted document can still be restored from the Command Center
// (server RETENTION_DAYS) — said in the dialog and the toast.
export const DELETION_RETENTION_DAYS = 30;

/** True once the answer is one the server accepts: a known reason, and a note for `other`. */
export function isDeletionReasonComplete(reason, note = '') {
  if (!DELETION_REASONS.some(r => r.key === reason)) return false;
  const text = String(note || '').trim();
  if (text.length > DELETION_REASON_NOTE_MAX) return false;
  return reason !== 'other' || text.length > 0;
}
